import { useMutation, useQuery } from "@tanstack/react-query";
import { CircularProgress, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import {
  getMedisendCredential,
  loginMedisend,
} from "../../../services/syncAccountApi";
import MedisendOtpModal from "./MedisendOtpModal";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";

const Medisend = () => {
  const [phone, setPhone] = useState("");
  const [openOtp, setOpenOtp] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSync = () => {
    mutateLogin({
      phone_number:
        credential && credential.status
          ? credential.phone_number
          : "+62" + phone,
    });
  };

  const {
    data: credential,
    isFetching: isFetchingCredential,
    error: errorCredential,
  } = useQuery({
    queryKey: ["medisend-cred"],
    queryFn: () => getMedisendCredential(),
    retry: 3,
    refetchOnWindowFocus: false,
  });

  const { mutate: mutateLogin, isLoading: isLoadingLogin } = useMutation({
    mutationFn: loginMedisend,
    onSuccess: () => setOpenOtp(true),
    onError: (err) =>
      setErrorMessage(err.message?.id ? err.message.id : err.message),
  });

  return (
    <div className="text-[12px]">
      <LoadingBackdrop isLoading={isLoadingLogin} />
      {credential && !isFetchingCredential && !credential.status ? (
        <p className="mb-2 bg-blue-100 p-2 rounded-md mb-4 font-bold">
          Silahkan masukan credential untuk sinkronisasi stok anda
        </p>
      ) : null}
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div>
          <div className="border-2 rounded-lg p-4 mb-3">
            {credential && !isFetchingCredential ? (
              credential.status ? (
                <>
                  <p className="text-lg font-bold mb-4">
                    Integrasi Akun Medisend
                  </p>
                  <p className="mb-4">
                    Akun telah berhasil terintegrasi ke nomor{" "}
                    {credential?.phone_number}, silahkan mensinkronisasi stok
                  </p>
                  <div className="flex justify-end">
                    <button
                      type="button"
                      className="bg-green-500 hover:bg-gray-300 text-white py-2 px-12 rounded-md font-bold disabled:bg-gray-300"
                      onClick={handleSync}
                      disabled={isLoadingLogin}
                    >
                      {isLoadingLogin ? <CircularProgress size={20} /> : "Sync"}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <p className="text-lg font-bold mb-4">
                    Integrasi Akun Medisend
                  </p>
                  <TextField
                    fullWidth
                    name="No. Telepon"
                    label="No. Telepon"
                    placeholder="812XXXXXXX"
                    autoComplete="false"
                    sx={{ marginBottom: 1 }}
                    value={phone}
                    onChange={(e) => {
                      if (!isNaN(Number(e.target.value)))
                        setPhone(e.target.value);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">+62</InputAdornment>
                      ),
                    }}
                  />
                  <div className="flex justify-end">
                    <button
                      type="button"
                      className="bg-blue-500 hover:bg-gray-300 text-white py-2 px-4 rounded-md font-bold disabled:bg-gray-300"
                      disabled={
                        phone.slice(0, 2) === "62" ||
                        phone[0] === "0" ||
                        phone === "" ||
                        isLoadingLogin
                      }
                      onClick={handleSync}
                    >
                      {isLoadingLogin ? (
                        <CircularProgress size={20} />
                      ) : (
                        "Integrasi"
                      )}
                    </button>
                  </div>
                </>
              )
            ) : (
              <div>
                {isFetchingCredential ? (
                  <div className="flex items-center gap-4">
                    <CircularProgress size={20} />
                    <p>Data sedang diproses</p>
                  </div>
                ) : (
                  <p className="text-red-500">
                    {errorCredential?.message?.id
                      ? errorCredential?.message.id
                      : errorCredential?.message
                      ? errorCredential?.message
                      : "Terjadi kesalahan dalam mengambil data"}
                  </p>
                )}
              </div>
            )}
          </div>

          <p className="italic text-xs px-2 text-right text-blue-500">
            Powered by OLIN
          </p>
        </div>
      </div>

      <MedisendOtpModal open={openOtp} setOpen={setOpenOtp} />
      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default Medisend;
